module.exports = __webpack_public_path__ + "static/media/pantalla_vertical.5990091d.png";